import { createApi } from '@reduxjs/toolkit/query/react'

import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { IMarkets } from 'src/core/classes/models/IMarkets'

import { getProcedureUrl } from './helpers/getBaseUrl'
import { getCustomQuery } from './helpers/getCustomQuery'
import { getResponseHandler } from './helpers/getResponseHandler'

export const referenceMarketsApi = createApi({
  reducerPath: '@app/api/referenceMarkets',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.markets,
    baseUrl: getProcedureUrl('spApp_getMarkets'),
  }),
  endpoints: (builder) => ({
    getReferenceMarkets: builder.query<IMarkets[], void>({
      query: () => {
        return {
          url: ``,
          method: 'POST',
          responseHandler: getResponseHandler({
            storageKey: StorageKeys.markets,
          }),
        }
      },
    }),
  }),
})

export const { useGetReferenceMarketsQuery } = referenceMarketsApi
